<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<ModalConfirmSendReport
			v-if="modalIsOpen && modalType === modalTypes.CONFIRM"
			:name="`${report?.group_plan?.order}`"
			@close="cancelSendReport"
			@submit="sendReport"
		/>
		<UpdateNoteModal
			v-if="
				modalIsOpen &&
				modalType === modalTypes.UPDATE_NOTE &&
				!!goalViewDetail
			"
			:goal="goalViewDetail"
			:group_class_id="Number(id)"
			:is-open="
				modalIsOpen &&
				modalType === modalTypes.UPDATE_NOTE &&
				!!goalViewDetail
			"
			:monthly_report_id="reportId || report?.data?.id"
			@close="cancelSendReport"
			@submit="updateNoteSuccess"
		/>
	</DaModalFrame>
	<div class="flex min-h-screen overflow-x-hidden">
		<div class="w-full flex">
			<div class="w-full pb-30">
				<div class="w-full p-10 md-down:px-4 gap-4">
					<div
						class="
							__breadcrumbs
							text-sm text-neutral-500
							font-semibold
							flex-nowrap flex
							items-center
							mb-4
						"
					>
						<router-link
							:to="{ name: ROUTER_NAME.REPORT_PLANS_GROUP }"
						>
							Báo cáo tháng
						</router-link>
					</div>
					<div class="flex items-center justify-between">
						<div v-if="report?.group_class" class="flex gap-2">
							<div class="w-7 h-7">
								<img
									alt=""
									src="@/assets/images/icons/people-fill.png"
								/>
							</div>
							<div>
								<div
									class="text-neutral-700 font-bold text-3xl"
								>
									{{ report?.group_class?.name }}
								</div>
								<div class="flex gap-4 items-center mt-2">
									<UserGroup
										:data="report?.group_class?.students"
										placement="bottom-start"
									/>
									<div
										class="
											uppercase
											text-green-500
											font-semibold
										"
									>
										{{
											report?.group_class?.students
												?.length
										}}
										học sinh
									</div>
								</div>
							</div>
						</div>
						<div class="flex gap-4">
							<div v-if="report && !report?.data?.sent_at">
								<button
									class="
										button-p
										text-center
										whitespace-nowrap
										w-fit
									"
									type="button"
									@click="openSendConfirm"
								>
									Gửi tới phụ huynh
								</button>
							</div>
							<div v-if="isEdit">
								<button
									class="
										button-p
										text-center
										w-fit
										btn--ghost
									"
									type="button"
									@click="isEdit = false"
								>
									Lưu báo cáo
								</button>
							</div>
						</div>
					</div>
					<div>
						<ReportDetail
							v-if="reportData"
							:is-edit="isEdit"
							:report="reportData"
							:student-selected="studentSelected"
							:students="report?.group_class?.students"
							@change-student="onChangeStudent"
							@open-modal="openUpdateNoteModal"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import UserGroup from '@/components/elements/UserGroup.vue';
import { _MODAL_TYPE as modalTypes, _MODAL_TYPE, _ROUTER_NAME } from '@/enums';
import { $api } from '@/services';
import ReportDetail from '@/views/planGroupDetail/ReportDetail.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import ModalConfirmSendReport from '@/views/planGroupDetail/ModalConfirmSendReport.vue';
import UpdateNoteModal from '@/views/planGroupEdit/UpdateNoteModal.vue';

export default {
	name: 'PlanGroupDetail',

	components: {
		UpdateNoteModal,
		ModalConfirmSendReport,
		DaModalFrame,
		ReportDetail,
		UserGroup,
	},

	data() {
		return {
			ROUTER_NAME: _ROUTER_NAME,
			report: null,
			studentReport: {},
			studentSelected: {
				id: 'all',
			},
			isEdit: false,
			isLoading: false,
			modalIsOpen: false,
			modalType: null,
			goalViewDetail: null,
		};
	},

	computed: {
		modalTypes() {
			return modalTypes;
		},
		id() {
			return this.$route.params?.id;
		},

		reportId() {
			return this.$route.query?.report_id;
		},

		reportData() {
			return this.studentSelected?.id !== 'all' &&
				this.studentReport[+this.studentSelected?.id]
				? this.studentReport[+this.studentSelected?.id]
				: this.report;
		},
	},

	watch: {
		'studentSelected.id': {
			deep: true,
			handler(value) {
				if (value !== 'all' && !this.studentReport[value]) {
					this.fetchStatsForStudentGroup();
				}
			},
		},
	},

	created() {
		this.fetchReport();
	},

	methods: {
		openUpdateNoteModal(item) {
			this.modalIsOpen = true;
			this.modalType = _MODAL_TYPE.UPDATE_NOTE;
			this.goalViewDetail = item;
		},

		onChangeStudent(student) {
			this.studentSelected = student;
		},

		async fetchReport() {
			try {
				const { data } =
					await $api.monthlyReport.detailMonthlyReportGroupClass(
						this.id,
						this.reportId
					);
				this.report = data;
			} catch (e) {
				console.log(e);
			}
		},

		async fetchStatsForStudentGroup() {
			this.isLoading = true;
			try {
				const {
					data: {
						data: {
							emotion_scale_stats,
							group_sessions_count,
							skills_stats,
							skills,
						},
					},
				} = await $api.monthlyReport.fetchStatsForStudentGroup(
					this.report?.group_class?.id,
					this.report?.data?.id,
					this.studentSelected?.id
				);
				this.studentReport[this.studentSelected?.id] = {
					...this.report,
					emotion_scale_stats,
					group_sessions_count,
					skills_stats,
					skills,
				};
			} catch (e) {
				console.log(e);
			} finally {
				this.isLoading = false;
			}
		},

		goToEdit() {
			this.isEdit = true;
		},

		openSendConfirm() {
			this.modalIsOpen = true;
			this.modalType = _MODAL_TYPE.CONFIRM;
		},

		cancelSendReport() {
			this.modalIsOpen = false;
			this.modalType = null;
			this.goalViewDetail = null;
		},

		updateNoteSuccess() {
			this.fetchStatsForStudentGroup();
			this.cancelSendReport();
		},

		async sendReport() {
			try {
				await $api.monthlyReport.sendMonthlyReportGroupClass(
					this.report?.group_class?.id,
					this.report?.data?.id
				);
				await this.$store.dispatch('setAlertMessage', {
					message: 'Gửi kế hoạch đến phụ huynh thành công',
				});
				this.report.data.sent_at = new Date();
				this.cancelSendReport();
			} catch (err) {
				await this.$store.dispatch('setAlertMessage', {
					message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},
	},
};
</script>
